import { Box } from "@mui/material";
import { BoxRoot } from "./AppCustomTabPanel.styles";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number | boolean;
    className?: string;
}

const AppCustomTabPanel = (props: TabPanelProps) => {
    const { children, value, index, className, ...other } = props;

    return (
        <BoxRoot
            className={className}
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            sx={{ width: 1 / 1 }}
            {...other}
        >
            {value === index &&
                <Box>
                    {children}
                </Box>
            }
        </BoxRoot>
    );
}

export default AppCustomTabPanel;